import { combineReducers } from 'redux';
import solgressReducer from './janusReducer';
import authReducer from './authReducer';
import CreateQuoteReduxState from './createQuoteReducer';
import quoteReducer from './quoteReducer';
import projectReducer from './projectReducer';
import dumpReducer from './dumpReducer';
import searchReducer from './searchReducer';

export default combineReducers({
  solgressReducer,
  authReducer,
  CreateQuoteReduxState,
  quoteReducer,
  projectReducer,
  dumpReducer,
  searchReducer,
});
